import { PatchesGridWebComponent } from './component/PatchesGridWebComponent';
import { WEB_COMPONENT_PATCHES_GRID } from '../../../../../../../webcomponents.constants';

window.customElements.define(WEB_COMPONENT_PATCHES_GRID, PatchesGridWebComponent);

export { PatchesGridWebComponent };
